export const mutations = {
    setContaReceber(state, data) {
        state.contaReceber = data
    },
    setContasReceber(state, data) {
        state.contasReceber = data
    },
    setMovimentacaoExtratContaReceber(state, data){
        state.movimentacaoExtratoContaReceber = data
    },
    setContaReceberPermissoesSelecionadas(state, data){
        state.contaReceberPermissoesSelecionadas = data
    }, 
    addContaReceber(state, data){
        state.contasReceber.push(data)
    },
    removeContaReceber(state, data){
        let index = state.contasReceber.data.map(x => x.id).indexOf(data.id);
        state.contasReceber.data.splice(index, 1)
    },
    setModalCadastrarContaReceber(state, status) {
        state.modalCadastrarContaReceber = status
    },
    setModalExcluirContaReceber(state, status) {
        state.modalExcluirContaReceber = status
    },
    setModalBaixaContaReceber(state, status) {
        state.modalBaixaContaReceber = status
    },
    setShowInputAnexoContaReceber(state, status){
        state.showInputAnexoContaReceber = status
    },
    setModalReciboTotalContaReceber(state, status) {
        state.modalReciboTotalContaReceber = status
    },
    setModalReciboParcialContaReceber(state, status) {
        state.modalReciboParcialContaReceber = status
    },
}

export default {}